import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["alt", "data-srcset", "srcset"]
const _hoisted_2 = ["media", "data-srcset", "srcset"]
const _hoisted_3 = ["media", "data-srcset", "srcset"]
const _hoisted_4 = ["alt"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_lazyload = _resolveDirective("lazyload")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($options.image)
      ? _withDirectives((_openBlock(), _createElementBlock("img", {
          key: 0,
          class: _normalizeClass(_ctx.$attrs.class),
          style: _normalizeStyle(_ctx.$attrs.style),
          alt: $props.alt,
          height: "auto",
          width: "auto",
          "data-srcset": $options.image.srcset,
          srcset: $props.lazyloaded ? $options.image.placeholder : $options.image.srcset
        }, null, 14, _hoisted_1)), [
          [_directive_lazyload, $props.lazyloaded]
        ])
      : (_openBlock(), _createElementBlock("picture", {
          key: 1,
          class: _normalizeClass(_ctx.$attrs.class)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.imagesMobile, (imageMobile) => {
            return _withDirectives((_openBlock(), _createElementBlock("source", {
              key: imageMobile.srcset,
              media: `(max-width: ${imageMobile.width}px)`,
              "data-srcset": `${imageMobile.srcset} 1x, ${imageMobile.srcsetRetina} 2x`,
              srcset: 
        $props.lazyloaded
          ? imageMobile.placeholder
          : `${imageMobile.srcset} 1x, ${imageMobile.srcsetRetina} 2x`
      
            }, null, 8, _hoisted_2)), [
              [_directive_lazyload, $props.lazyloaded]
            ])
          }), 128)),
          (!$data.isDeviceMobile)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($options.images, (image, i) => {
                return _withDirectives((_openBlock(), _createElementBlock("source", {
                  key: image.srcset,
                  media: i + 1 !== $options.images.length ? `(max-width: ${image.width}px) ` : '',
                  "data-srcset": `${image.srcset} 1x, ${image.srcsetRetina} 2x`,
                  srcset: $props.lazyloaded ? image.placeholder : `${image.srcset} 1x, ${image.srcsetRetina} 2x`
                }, null, 8, _hoisted_3)), [
                  [_directive_lazyload, $props.lazyloaded]
                ])
              }), 128))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            alt: $props.alt,
            height: "auto",
            width: "auto",
            class: _normalizeClass(_ctx.$attrs.class),
            style: _normalizeStyle(_ctx.$attrs.style)
          }, null, 14, _hoisted_4)
        ], 2)),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}